
import {
    Box,
    Button,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Grid,
    Divider,
    IconButton,
    CircularProgress
} from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Pencil } from 'lucide-react'
import apiUrl from '../../Config'

const DisplayBlogs = () => {
    const navigate = useNavigate()
    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const getAllBlogs = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${apiUrl}/blogs/getallblogs`)
            setBlogs(response.data.blogs)
        } catch (error) {
            console.log(error)
            const message = error?.response?.data?.message || error.message || 'Failed to fetch blogs'
            setError(message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllBlogs()
    }, [])

    const formatDate = (dateStr) => {
        const date = new Date(dateStr)
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        })
    }

    const handleEdit = (blog) => {
        navigate('/create-edit-blogs', { state: { blog } })
    }

    return (
        <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h4" fontWeight={600}>
                    All Blogs
                </Typography>

                <Button variant="contained" onClick={() => navigate('/create-edit-blogs')}>
                    Add Blog
                </Button>
            </Box>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {blogs.length > 0 ? (
                        blogs.map((blog) => (
                            <Grid size={{ xs: 12 }} key={blog.id}>
                                <Card
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: 'row' }, // stack on xs, side-by-side on md+
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        height: '100%',
                                    }}
                                >
                                    {/* Blog Image on Left for md+ screens */}
                                    {blog.imageUrl && (
                                        <CardMedia
                                            component="img"
                                            image={blog.imageUrl}
                                            alt="Blog Cover"
                                            sx={{
                                                width: { xs: '100%', md: 300 },
                                                height: { xs: 200, md: 'auto' },
                                                objectFit: 'cover',
                                                flexShrink: 0,
                                            }}
                                        />
                                    )}

                                    {/* Blog Content */}
                                    <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="h6" fontWeight={600} gutterBottom>
                                            {blog.title}
                                        </Typography>
                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                            By {blog.name} • {formatDate(blog.createdAt)}
                                        </Typography>
                                        <Divider sx={{ my: 1 }} />
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            component="div"
                                            sx={{ flexGrow: 1 }}
                                            dangerouslySetInnerHTML={{ __html: blog.content }}
                                        />
                                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                            <Button variant="contained" color="primary" onClick={() => handleEdit(blog)}>
                                                Edit
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                    ) : (
                        <Grid size={{ xs: 12 }}>
                            <Typography textAlign="center">No blogs found.</Typography>
                        </Grid>
                    )}
                </Grid>
            )}

            {error && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                    {error}
                </Typography>
            )}
        </Box>
    )
}

export default DisplayBlogs
